import React from 'react'
import ToastMessage, { notificationType as NotificationType } from '@/Components/FdComponents/ToastMessages'

type Toast = {
  id: number
  toastMessage: string
  toastMessageType: string
}

type ToastsArguments = {
  toastMessage: string
  toastMessageType: string
}

type ToastsContextType = {
  showToast: (toastsArguments: ToastsArguments) => void
}

type ToastsContextProviderProps = {
  children: React.ReactNode
}

const ToastsContext = React.createContext<ToastsContextType>({} as ToastsContextType)

const ToastsContextProvider: React.FC<ToastsContextProviderProps> = (props) => {
  const [toasts, setToasts] = React.useState<Toast[]>([])

  const handleShow = (toastsArguments: ToastsArguments): void => {
    const { toastMessage, toastMessageType } = toastsArguments

    const newToast: Toast = {
      id: Date.now(),
      toastMessage,
      toastMessageType
    }

    setToasts((prevToasts) => [...prevToasts, newToast])
  }

  const [modalContext] = React.useState<ToastsContextType>({
    showToast: handleShow
  })

  return (
    <ToastsContext.Provider value={modalContext}>
      {props.children}
      {toasts.map((toast) => (
        <ToastMessage key={toast.id} message={toast.toastMessage} type={toast.toastMessageType as NotificationType} toastOpen={true} />
      ))}
    </ToastsContext.Provider>
  )
}

const useToastsContext = (): ToastsContextType => React.useContext(ToastsContext)

export { useToastsContext }

export default ToastsContextProvider
